import { useGetDatapointValues } from '../../MetricsTable/MetricsTableComponents/InputFields/QuantitativeInputs';
import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { QuestionType_Enum_, ShortUser } from '../../../../../../../models';
import { MDRM_QUESTIONS, MdrmTypeEnum, useMdrmAnswers } from '../../MDRM';
import { TimePeriodsEnums } from '../../../Requirement.ts';
import { VStack } from '@chakra-ui/react';
import { AssessableMetrics } from '../../Metrics';
import { AggregatedMetricsTableData } from '../../AggregatedMetrics';
import { MetricsTableData } from '../../MetricAnswers.hooks.ts';
import { SelectedMetric } from '../../../../../EsrsAssessment.hooks.ts';
import {
  ClickableReportAnswerComponent,
  MdrmEditableInput,
} from './ReportClickableAnswers/ClickableReportAnswer.tsx';

export const StackedMdrmHardcodedTables = ({
  metric,
  aggregatedMetric,
  companyLevelReportingUnitId,
  projectLeader,
  padding = 24,
  rowData,
  selectedMetric,
  setSelectedMetric,
  setRowData,
  selectedMdrm,
  setSelectedMdrm,
}: {
  metric?: AssessableMetrics[number];
  aggregatedMetric?: AggregatedMetricsTableData;
  companyLevelReportingUnitId?: string;
  projectLeader?: ShortUser;
  rowData?: MetricsTableData;
  padding?: number;
  selectedMetric?: SelectedMetric | null;
  setSelectedMetric: (metric: SelectedMetric) => void;
  setRowData: Dispatch<SetStateAction<MetricsTableData | undefined>>;
  selectedMdrm?: string;
  setSelectedMdrm?: (mdrm: string) => void;
}) => {
  const { answer, dataPointPerYear } = useGetDatapointValues(
    {
      metric,
    },
    companyLevelReportingUnitId ?? ''
  );
  const { answers: mdrmAnswers, onMdrmAnswerChange } = useMdrmAnswers({
    metricRef: metric.reference,
    row: aggregatedMetric ?? { metric },
    datapointId: dataPointPerYear?.id,
    companyReportingUnitId: companyLevelReportingUnitId,
    timeframe: TimePeriodsEnums.year,
  });

  const isEntitySpecific = useMemo(
    () =>
      metric.additionalTypes.some((type) => {
        return type.additionalType.reference === 'Entity-specific';
      }),
    [metric]
  );

  const mappedMdrms = useMemo(() => {
    return MDRM_QUESTIONS.filter((q) => {
      if (q.id === MdrmTypeEnum.entitySpecific) {
        return isEntitySpecific;
      }
      return true;
    }).map((q) => {
      return {
        id: q.id,
        question: q.question,
        answer: mdrmAnswers[q.id],
      };
    });
  }, [mdrmAnswers, isEntitySpecific]);

  return (
    <ClickableReportAnswerComponent
      metric={metric}
      aggregatedMetric={aggregatedMetric}
      projectLeader={projectLeader}
      rowData={rowData}
      selectedMetric={selectedMetric}
      setSelectedMetric={setSelectedMetric}
      setRowData={setRowData}
      padding={padding}
      answer={answer}
    >
      {dataPointPerYear?.isMdrmDisclosed && (
        <VStack w="100%" spacing="12px">
          {mappedMdrms.map((mdrm) => (
            <MdrmEditableInput
              key={mdrm.answer?.id}
              mdrm={mdrm}
              onMdrmAnswerChange={onMdrmAnswerChange}
              projectLeader={projectLeader}
              selectedMdrm={selectedMdrm}
              setSelectedMdrm={setSelectedMdrm}
            />
          ))}
        </VStack>
      )}
    </ClickableReportAnswerComponent>
  );
};
